import { Typography } from "@circle-react-uikit/Typography";

interface FeatureItemProps {
  description: string;
  icon: React.ReactNode;
  title: string;
}

export const FeatureItem = ({ icon, title, description }: FeatureItemProps) => (
  <div className="flex gap-x-5 align-top">
    <div className="flex size-8 p-[6px] items-center justify-center rounded-full bg-secondary text-secondary">
      {icon}
    </div>
    <div>
      <Typography.LabelSm weight="semibold">{title}</Typography.LabelSm>
      <Typography.BodySm color="text-default">{description}</Typography.BodySm>
    </div>
  </div>
);
